<template>
  <div>
    <card card-body-classes="" no-footer-line>
      <h4 slot="header" class="title title-up">{{ (scope == 'edit') ? 'Update' : 'Create New' }} Course</h4>
      <form>
        <div class="row">
            <div class="col-6">
                <fg-input
                    type="text"
                    required
                    name="code"
                    label="Course Code"
                    v-validate="modelValidations.code"
                    :error="getError('code')"
                    v-model="model.code">
                </fg-input>
            </div>
            <div class="col-6">
                <fg-input
                    type="text"
                    required
                    name="deanery"
                    label="Deanery"
                    v-validate="modelValidations.deanery"
                    :error="getError('deanery')"
                    v-model="model.deanery">
                    <el-select class="select-primary" placeholder="Select Deanery" v-model="model.deanery">
                        <el-option v-for="(option, index) in deaneries" class="select-primary" :value="option" :label="option" :key="index">
                        </el-option>
                    </el-select>
                </fg-input>
            </div>
            <div class="col-6 mt-4">
                <fg-input
                    type="text"
                    required
                    name="title"
                    label="Course Title"
                    v-validate="modelValidations.title"
                    :error="getError('title')"
                    v-model="model.title">
                </fg-input>
            </div>
            <div class="col-6 mt-4">
                <fg-input
                    type="text"
                    required
                    name="pdf"
                    label="Course Syllabus PDF"
                    v-validate="modelValidations.pdf"
                    :error="getError('pdf')"
                    v-model="model.pdf"
                    description="upload PDF which are less than 4MB">
                    <el-upload
                        class="upload-demo"
                        list-type="text"
                        name="pdf"
                        accept="application/pdf"
                        :data="{path: 'tukio/programmes/pdf'}"
                        :action="uploadURL"
                        :headers="headers"
                        :show-file-list="true"
                        :on-success="handleFileSuccess"
                        :before-remove="handleRemove">
                        <n-button type="primary" round block size="small" style="margin-top: 0">Click to Upload</n-button>
                    </el-upload>
                </fg-input>
            </div>
            <div class="col-6 mt-4">
                <fg-input
                    type="text"
                    name="description"
                    label="Description"
                    v-validate="modelValidations.description"
                    :error="getError('description')"
                    v-model="model.description">
                    <ckeditor :editor="editor" v-model="model.description" :config="editorConfig"></ckeditor>
                </fg-input>
            </div>
            <div class="col-6 mt-4">
                <!-- <pdf :src="model.pdf" v-if="model.pdf">
                    <template slot="loading">
                        loading syllabus content here...
                    </template>
                </pdf> -->
                <PDFVuer :src="model.pdf" v-if="model.pdf" />
            </div>
            <div class="col-12 text-center">
            <n-button @click.native.prevent="validate()" type="primary">Save Course</n-button>
            </div>
        </div>
      </form>
    </card>
  </div>
</template>

<script>
import { Card, PDFVuer } from 'src/components';
import { Select, Option, Upload, Button } from "element-ui";
import pdf from 'pdfvuer'
import { mapGetters } from 'vuex';

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import BalloonEditor from '@ckeditor/ckeditor5-build-balloon';

export default {
  components: {
    Card,
    pdf,
    PDFVuer,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [Upload.name]: Upload
  },
  computed: {
    ...mapGetters({
        deaneries: 'getDeaneries',
        authTokens: 'getAuthTokens',
        paper: 'getPaper',
    }),
    scope(){
      return this.$route.path.includes('edit') ? 'edit' : 'add'
    },
    headers(){
        this.authTokens['content-type'] = 'multipart/form-data'
        let {token, refreshtoken} = this.authTokens
        return {token, refreshtoken};
    },
    uploadURL(){
        return `${process.env.VUE_APP_BASE_URL}/admin/papers/pdf`
    }
},
  data() {
    return {
        loading: false,
        model: {
            slug: null,
            code: '',
            title: '',
            description: '',
            deanery: '',
            pdf: null
        },
        modelValidations: {
            code: {
                required: true,
            },
            title: {
                required: true,
            },
            department: {
                required: true,
            },
            deanery: {
                required: true,
            },
            pdf: {
                required: false,
            },
        },
        editor: ClassicEditor,
        editorConfig: {
            // The configuration of the editor.
        },
        filterMethod(query, item) {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        }
    };
  },
  methods: {
    getError(fieldName) {
        return this.errors.first(fieldName);
    },
    validate() {
        this.$validator.validateAll().then(isValid => {
            if(isValid){
                switch(this.scope){
                    case 'add'  : this.$store.dispatch('createPaper', Object.assign({}, this.model)); break;
                    case 'edit' : this.$store.dispatch('updatePaper', Object.assign({}, this.model)); break;
                }
            }
        });
    },
    handleFileSuccess(res, file) {
        this.model.pdf = res.data.file;
    },
    handleRemove(file, fileList){
      this.model.pdf = null
    },
  },
  mounted() {
    this.$store.dispatch('getDeaneries')
    
    if(this.scope == 'edit'){
      this.$store.dispatch('getPaper', this.$route.params.slug)
    }
  },
  watch: {
      paper(value){
          this.model = Object.assign({}, value)
      }
  }
};
</script>

<style lang="scss">
.has-success.has-label:after, 
.has-danger.has-label:after {
    top: 43px;
}

.el-transfer-panel__filter.el-input{
  width: 85%;
}

.bootstrap-switch{
  display: block;
  width: 90px!important;
  height: 35px!important;

  &.bootstrap-switch-on{
      .bootstrap-switch-label{
          left: 70%;
      }
  }

  .bootstrap-switch-label{
      width: 35px!important;
      height: 35px!important;
  }

  .bootstrap-switch-handle-off,
  .bootstrap-switch-handle-on{
      font-weight: bold;
      line-height: 22px;
      text-indent: 10px;
      color: #273c75!important;
      width: 100%!important;
  }
  .bootstrap-switch-handle-off{
      text-indent: 15px;
  }
}

.ck-editor__editable {
  min-height: 300px;
  }

  .el-select-dropdown__wrap{
      height: 400px!important;
      max-height: 400px!important;
  }

  .el-upload{
      width: 100%;
  }
</style>
